import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { SignUpPage } from './pages/SignUpPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ConfirmSignUpPage } from './pages/ConfirmSignUpPage';
import { HomeContentProvider } from './contexts/HomeContentContext';

// Import pages
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import VideoCatalog from './pages/VideoCatalog';
import AudioCatalog from './pages/AudioCatalog';
import EBookCatalog from './pages/EBookCatalog';
import ProductsPage from './pages/ProductsPage';
import JournalPage from './pages/JournalPage';

import PersonalizedMantraPage from './pages/PersonalizedMantraPage';
import ChakraEducationPage from './pages/ChakraEducationPage';


import SuccessfulPurchase from './pages/SuccessfulPurchase';
import CanceledPurchase from './pages/CanceledPurchase';
import UpdatesPage from './pages/UpdatesPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';


function AppContent() {
  const { theme } = useTheme();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <HomeContentProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Auth Routes */}
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/confirm-signup" element={<ConfirmSignUpPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/cta" element={<LandingPage />} />
                
                {/* Protected Routes */}
                <Route path="/" element={
                  <PrivateRoute>
                    <LoginPage />
                  </PrivateRoute>
                } />
                <Route path="/home" element={
                  <PrivateRoute>
                    <HomePage />
                  </PrivateRoute>
                } />
                <Route path="/video" element={
                  <PrivateRoute>
                    <VideoCatalog />
                  </PrivateRoute>
                } />
                <Route path="/audio" element={
                  <PrivateRoute>
                    <AudioCatalog />
                  </PrivateRoute>
                } />
                <Route path="/ebooks" element={
                  <PrivateRoute>
                    <EBookCatalog />
                  </PrivateRoute>
                } />
                <Route path="/journal" element={
                  <PrivateRoute>
                    <JournalPage />
                  </PrivateRoute>
                } />
                <Route path="/products" element={
                  <PrivateRoute>
                    <ProductsPage />
                  </PrivateRoute>
                } />
                <Route path="/personalized-mantra" element={
                  <PrivateRoute>
                    <PersonalizedMantraPage />
                  </PrivateRoute>
                } />
                <Route path="/ebooks" element={
                  <PrivateRoute>
                    <EBookCatalog />
                  </PrivateRoute>
                } />
                <Route path="/chakra-education" element={
                  <PrivateRoute>
                    <ChakraEducationPage />
                  </PrivateRoute>
                } />
                <Route path="/purchase-success" element={
                  <PrivateRoute>
                    <SuccessfulPurchase />
                  </PrivateRoute>
                } />
                <Route path="/purchase-canceled" element={
                  <PrivateRoute>
                    <CanceledPurchase />
                  </PrivateRoute>
                } />
                <Route path="/updates" element={
                  <PrivateRoute>
                    <UpdatesPage />
                  </PrivateRoute>
                } />
                <Route path="/profile" element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                } />
                <Route path="/settings" element={
                  <PrivateRoute>
                    <SettingsPage />
                  </PrivateRoute>
                } />
              </Routes>
            </div>
          </Router>
        </HomeContentProvider>
      </AuthProvider>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App; 